import { useAdminBaselines } from "@/hooks/useAdminBaselines";
import { useBaselineStore } from "@/stores/baseline-store";

export function BaselineSelector() {
  const { data: baselines, isLoading } = useAdminBaselines();
  const baselineId = useBaselineStore((s) => s.baselineId);
  const setBaselineId = useBaselineStore((s) => s.setBaselineId);

  return (
    <select
      value={baselineId ?? ""}
      onChange={(e) => setBaselineId(e.target.value || null)}
      className="rounded-md border bg-background px-3 py-1.5 text-sm"
      disabled={isLoading}
    >
      <option value="">All time</option>
      {baselines?.map((b) => (
        <option key={b.id} value={b.id}>
          {b.name} ({new Date(b.created_at).toLocaleDateString()})
        </option>
      ))}
    </select>
  );
}
